import { Theme } from '@blockanalitica/ui/package/types/src/theme/ThemeProvider';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function cardHeader(theme: Theme): ComponentStyle {
  return {
    componentName: 'cardHeader',
    baseStyle: {
      backgroundColor: theme.colors.onSurface100,
      color: theme.colors.muted,
      fontSize: theme.sizes[-1],
      fontWeight: 500,
      display: 'flex',
      padding: theme.space.s,
      borderTopLeftRadius: theme.sizes[-3],
      borderTopRightRadius: theme.sizes[-3]
    }
  };
}
